import React, { FunctionComponent } from 'react';
import { faFileContract } from '@fortawesome/free-solid-svg-icons';
import { BrassIcon, BrassIconProps } from '..';

const BrassIconReasonForContractChange: FunctionComponent<BrassIconProps> = (
  props: BrassIconProps,
) => <BrassIcon {...props} icon={faFileContract} />;

export { BrassIconReasonForContractChange };
